import React from 'react'

const Layout = ({ children }) => <div className="u-sizeFullHeight u-relative">{children}</div>

export default Layout
